import { ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import 'rxjs/add/operator/filter';
import { GoalsService } from "src/app/_services/goals/goals.service"
import { LocalStorageService } from "src/app/_services/localStorage/local-storage.service";
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import * as _ from 'lodash';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from '../../../../_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { Router } from '@angular/router';
import { MatSnackBar } from "@angular/material/snack-bar";
import { Designation } from 'src/app/_helpers/designation';

@Component({
  selector: 'app-goal',
  templateUrl: './goal.component.html',
  styleUrls: ['./goal.component.scss']
})
export class GoalComponent implements OnInit {

  defTempForm
  performancegoalsForm
  goalsStatusChangeForm
  form: FormGroup;
  filterForm: FormGroup;
    // row data and column definitions  
    rowData: any;
    public columnDefs: ColDef[]; 
    modeAction:number = 1 //1 - create // 2 - update
    // gridApi and columnApi  
    private api: GridApi;  
    private columnApi: ColumnApi;  
    defaultColDef:any;
    rowSelection:any
    tenantId: string;
    userDetails: any;
    dataSource_performancegoals: any;
    gridLength = 0;
    sampleGridFrameworkComponents: any;
    selectedCheckboxData = [];
    deleteConfirmationMsg = 'Are you sure you want to delete';
    // userDropdownList = [];
    userDropdownList: Array<any> = [];
    getUserName: any;
    currentUser: any;
    goalsArray: any[] = [];
    goalsResponse : any[] = [];
    designationArray = Designation;
    isManager: boolean;
    isSupervisor: boolean = false;
    isAdmin: boolean = false;
    isPMOAdmin: boolean = false;

  constructor(
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private allocationService: AllocationService,
    private goalsService: GoalsService,
    private router: Router,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
    ) {
      this.defaultColDef = {
        flex: 1,
        minWidth: 100,
        resizable: true,
      };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs(); 

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });
    
    this.defTempForm = this.formBuilder.group({
      designation: new FormControl('', Validators.required),
      year: new FormControl('', Validators.required),
      userId: new FormControl('', Validators.required),
    });

    this.filterForm = this.formBuilder.group({
      userId: new FormControl(''),
      year: new FormControl('')
    });

    this.goalsStatusChangeForm = this.formBuilder.group({
      status: new FormControl(''),
      year: new FormControl(''),
      userId: new FormControl(''),
    });

    this.performancegoalsForm = this.formBuilder.group({
      title: new FormControl('', Validators.required),
      status: new FormControl('', Validators.required),
      weightage: new FormControl('', Validators.required),
      deadline: new FormControl('', Validators.required),
      description: new FormControl(''),
      comment: new FormControl(''),
      userId: new FormControl(''),
      userName: new FormControl(''),
      startDate: new FormControl('', Validators.required),
      endDate: new FormControl(''),
      createdByUserId: new FormControl(''),
      createdByUserName: new FormControl(''),
      year: new FormControl(''),
      kra: new FormControl(''),
      kpi: new FormControl(''),
      midYearReview: new FormControl(''),
      endYearReview: new FormControl(''),
      employeeScore: new FormControl(''),
      ratingByManager: new FormControl(''),
      managerRatingScore: new FormControl(''),
      base: new FormControl(''),
      target: new FormControl(''),
    });
   }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.isAdmin = this.currentUser.roles.includes('RoleHrmAdministrator');
    this.isPMOAdmin = this.currentUser.roles.includes('RolePmoAdministrator');
    this.getUserList();
    this.getperformancegoalsDetails();
  }

  // getter for easy access to form fields
  get f() {
    return this.performancegoalsForm.controls;
  }

  getperformancegoalsDetails() {  
    this.goalsService.getGoalFilters().subscribe((response: any) => {
      // this.rowData = response;
      this.goalsResponse = response;
      this.goalsArray = [];
      let year = new Date().getFullYear().toString();
      this.goalsArray = response.filter(item => (item.year === year));
      this.rowData = this.goalsArray;
    })
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }  

  // create column definitions  
  private createColumnDefs() {
  return [
    {
      headerName: 'Employee Name',
      filter: true,
      editable: false,
      sortable: true,
      valueGetter: function(params) {
        return params.data.userId + " . " + params.data.username + " - " + params.data.year;
      },
      cellRenderer: this.createHyperLink.bind(this),
    },
    {
      headerName: 'Year',
      field: 'year',
      filter: true,
      editable: false,
      sortable: true,
    },
    {
      headerName: 'Status',
      field: 'status',
      filter: true,
      editable: false,
      sortable: true,
    },
  ] }

  creategoal() {
    let details = {
      title: this.performancegoalsForm.get('title').value,
      status: 'New',
      weightage: parseInt(this.performancegoalsForm.get('weightage').value.toString()),
      deadline: this.performancegoalsForm.get('deadline').value.substring(0,10)+" "+this.performancegoalsForm.get('deadline').value.substring(11,16)+":00",
      description: this.performancegoalsForm.get('description').value,
      comment: this.performancegoalsForm.get('comment').value,
      userId: this.performancegoalsForm.get('userId').value.toString().includes(".") ? this.performancegoalsForm.get('userId').value.split('.')[0].trim() : this.performancegoalsForm.get('userId').value,
      username: this.performancegoalsForm.get('userId').value.toString().includes(".") ? this.performancegoalsForm.get('userId').value.split('.')[1].trim() : "",
      startDate: this.performancegoalsForm.get('startDate').value.substring(0,10)+" "+this.performancegoalsForm.get('startDate').value.substring(11,16)+":00",
      endDate: this.performancegoalsForm.get('endDate').value.substring(0,10)+" "+this.performancegoalsForm.get('endDate').value.substring(11,16)+":00",
      createdByUserId: this.performancegoalsForm.get('userId').value.toString().includes(".") ? this.performancegoalsForm.get('userId').value.split('.')[0].trim() : this.performancegoalsForm.get('userId').value,
      createdByUserName: this.performancegoalsForm.get('userId').value.toString().includes(".") ? this.performancegoalsForm.get('userId').value.split('.')[0].trim() : this.performancegoalsForm.get('userId').value,
      year: this.performancegoalsForm.get('year').value,
      kra: this.performancegoalsForm.get('kra').value,
      kpi: this.performancegoalsForm.get('kpi').value,
      midYearReview: parseInt(this.performancegoalsForm.get('midYearReview').value.toString()),
      endYearReview: parseInt(this.performancegoalsForm.get('endYearReview').value.toString()),
      employeeScore:   parseInt(this.performancegoalsForm.get('employeeScore').value.toString()),
      ratingByManager: this.performancegoalsForm.get('ratingByManager').value,
      managerRatingScore: parseInt(this.performancegoalsForm.get('managerRatingScore').value.toString()),
      base: this.performancegoalsForm.get('base').value,
      target: this.performancegoalsForm.get('target').value,
    }
    this.goalsService.createPerformancegoalsDetails(details).subscribe({
      next : (value) => {
        this.getperformancegoalsDetails();
        $('#closeCreateModal').trigger("click");
      },
      error(err) {
        this.openSnackBar('ERROR: cannot update project: ' + err);
      },
      complete() {
        this.openSnackBar('Templates assigned successfully!!!');
      }
    });
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  createOpenModal() {
    this.modeAction = 1;
    this.performancegoalsForm.reset();
    this.performancegoalsForm.patchValue({
      title: '',
      status: '',
      weightage: '',
      deadline: '',
      description: '',
      comment: '',
      userId: '',
      startDate: '',
      endDate: '',
      createdByUserId: '',
    });
  }

  tepmpateOpenModal(){
    this.modeAction = 1;
    this.defTempForm.reset();
  }

  changeStatusOpenModal(){
    this.modeAction = 1;
    let currentYear = new Date().getFullYear();
    this.goalsStatusChangeForm.reset();
    this.goalsStatusChangeForm.patchValue({
      year: currentYear,
      status: '',
    });
  }

  changeStatus() {
    let status = this.goalsStatusChangeForm.get('status').value;
    let year = this.goalsStatusChangeForm.get('year').value;
    let userIds = [];
    
    let resourceData = this.goalsStatusChangeForm.get('userId').value.toString().replaceAll(",", " , ");

    // 1. abhijeet sakhalkar , 2 . Vrushali Abhijeet
    let allUsers : any [] = resourceData.split(" , ");
    for(let i=0;i<allUsers.length; i++) {
      userIds.push(allUsers[i].split(" . ")[0]);
    }
    console.log("userIds, year, status : ", userIds, year, status);
    this.goalsService.updateUserGoalStatus(userIds, year, status).subscribe((response) => {
      this.getperformancegoalsDetails();
      $('#closeStatusModal').trigger("click");
    });
  }

  getUserList() {
    this.userDropdownList = [];
    // this.allocationService.getUserDetails().subscribe((response) => {
    //   this.userDropdownList = response.map((item: any) => `${item.id} . ${item.firstName} ${item.lastName}`);
    // });
    // this.cdr.detectChanges();


    if(this.isAdmin || this.isPMOAdmin){
      this.allocationService.getUserDetails().subscribe((response) => {
        this.userDropdownList = response.map((item: any) => `${item.id} . ${item.firstName} ${item.lastName}`);
        this.userDropdownList.push(
          `0 . All Users`
        );
      });
    }
    else{
      this.allocationService.getReportees().subscribe((response) => {
        if(response.length>0){
          this.isSupervisor = true;
          this.userDropdownList = response.map((item: any) => `${item.id} . ${item.firstName} ${item.lastName}`);
          // for (let item of response) {
          //   this.userDropdownList.push(
          //     `${item.id} . ${item.firstName} ${item.lastName}`
          //   );
          // }
        }
      });
    }
    this.cdr.detectChanges();
  }

  getDefaultTemp(){
    let resourceData : String;
    resourceData = this.defTempForm.get('userId').value.toString().replaceAll(",", " , ");

    // 1. abhijeet sakhalkar , 2 . Vrushali Abhijeet
    let allUsers : any [] = resourceData.split(" , ");
    let ids : any [] = [];
    for(let i=0;i<allUsers.length; i++) {
        ids.push(allUsers[i].split(" . ")[0]);
    }

    let details = {
      ids: ids,
    }
    console.log(ids);

    // let userId = this.defTempForm.get('userId').value.toString().includes(".") ? this.defTempForm.get('userId').value.split('.')[0].trim() : this.defTempForm.get('userId').value;
    let designation = this.defTempForm.get('designation').value;
    let year = this.defTempForm.get('year').value;
    this.goalsService.createAssignDefaultTemplatesToUserV2(details, designation, year).subscribe({
      next: (value: any) => {
          this.getperformancegoalsDetails();
          $('#closereport_form').trigger("click");
      },
      error(error){
        this.openSnackBar('ERROR: ' + error);
      },
      complete() {
        this.openSnackBar('Templates assigned successfully!!!');
      }
    });
  }

  getPerformanceReport(){
    this.goalsArray = [];
    let userId = parseInt(this.filterForm.get('userId').value.split(' . ')[0]);
    let year = this.filterForm.get('year').value;
    if(userId && year){
      this.goalsArray = this.goalsResponse.filter(item => (item.userId === userId && item.year === year));
      this.rowData = this.goalsArray;
    }
    else if(!userId && year){
      this.goalsArray = this.goalsResponse.filter(item => (item.year === year));
      this.rowData = this.goalsArray;
    }
    else{
      this.snackBar.open('Please select Employee Name and/or Year!', 'Close', { duration: 3000 });
    }
  }

  createHyperLink(params): any {
    if (!params.data) { return; }
    const spanElement = document.createElement('span');
    spanElement.innerHTML = `<a href="${params.value}" > ${params.value} </a> `;
    let id = params.value.split(' . ')[0];
    let year = params.value.split(' - ')[1];
    const status = params.data.status || '';
    const statusList = status.replace(/\s+or\s+/gi, ',').split(',').map(s => s.trim()).filter(s => s); // remove empty values
    const lastStatus = statusList[statusList.length - 1];
    const firstStatus = statusList[0];
    spanElement.addEventListener('click', ($event) => {
      $event.preventDefault();
      // The below code is used to navigate from one page to another page in angular. you can change it
      // according to your requirement.
      if(firstStatus === 'New' ){
        this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goals-objective'], {queryParams: { userId: id, year: year}});
      }
      else if(firstStatus === 'Approved' || firstStatus === 'Manager Approval'){
        this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goal-approved'], {queryParams: { userId: id, year: year}});
      }
      else if(firstStatus === 'Mid-Year Review'){
        this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goal-midreview'], {queryParams: { userId: id, year: year}});
      }
      else if(firstStatus === 'End-Year Review'){
        this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goal-endreview'], {queryParams: { userId: id, year: year}});
      }
      else if(firstStatus === 'HR Review'){
        this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goals-calibration'], {queryParams: { userId: id, year: year}});
      }
      else if(firstStatus === 'Acknowledge'){
        this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goals-objective'], {queryParams: { userId: id, year: year}});
      }

    });
    return spanElement;
  }

  backToGoalProfile(){
    this.router.navigate([this.tenantId + '/dashboard/hr/goal-profile-hr/goal-profile']);
  }

}